import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { KzIconsRegistryService } from '../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsArrowleft } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowleft.icon';
import { kzIconsArrowright } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowright.icon';

@Component({
  selector: 'app-diapo-button',
  template: `<button><kz-icons [name]="direction == 'prev' ? 'arrowleft' : 'arrowright'"></kz-icons></button>`,
  styleUrls: ['./diapo-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DiapoButtonComponent implements OnInit {

  @HostBinding('class.kz-diaporama--button') dispoClass = true;

  @HostBinding('class')
  get buttonDirection(): string {
    return `kz-diaporama--${this.direction}`;
  }

  @Input() direction: 'prev' | 'next' = 'prev';

  constructor(
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
  }

  ngOnInit(): void {
    this.kzIconsRegistryService.registerIcons([this.direction === 'prev' ? kzIconsArrowleft : kzIconsArrowright]);
  }

}
